import type { PropsWithChildren, ReactNode } from 'react';
import type { ChakraProps, FlexProps } from '@chakra-ui/react';
import { Box, Flex, keyframes } from '@chakra-ui/react';

import { useAppHeight } from '@izimi/hooks';

const pageFadeIn = keyframes`
  from { opacity: 0; }
`;

interface Props extends Omit<ChakraProps, 'transition'> {
  navigation: ReactNode;
  animationKey?: string;
  containerProps?: FlexProps;
}

export const BaseLayout = ({
  children,
  navigation,
  containerProps,
  animationKey,
  ...chakraProps
}: PropsWithChildren<Props>) => {
  const appHeight = useAppHeight();

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      height={appHeight}
      overflow='auto'
      {...containerProps}>
      {navigation}
      <Box key={animationKey} flex={1} animation={`${pageFadeIn} 0.25s ease-out`} {...chakraProps}>
        {children}
      </Box>
    </Flex>
  );
};
